module.exports = __webpack_public_path__ + "img/neteller_icon.68abf667.png";